<template>
  <div style="height: 100%; position: relative" class="mapDiv">
    <map-nav-bar :btmList="btmList" class="zzgl-nav-bar" />
    <div class="zhwl-map-btn" @click="openNewPage(2)">
      品种改良
    </div>
    <div class="zhwl-map-btn" style="right:32%" @click="showZhwlMap()">
      智慧物联
    </div>
    <div class="zhwl-map-btn" style="right:37%" @click="openNewPage(1)">
      生产监控
    </div>
    <div id="map" class="map"></div>
    <c-name
      v-if="JSON.stringify(param) !== '{}'"
      :param="param"
      class="detail"
    ></c-name>
    <c-detail
      v-if="JSON.stringify(poisiton) !== '{}'"
      :form="poisiton"
      class="detail"
    ></c-detail>
  </div>
</template>

<script>
//种植基地
import { Loading } from "element-ui";
import * as L from "leaflet";
import "proj4";
import "proj4leaflet";
const esri = require("esri-leaflet");
import "leaflet/dist/leaflet.css";
import cName from "../util/name";
import cDetail from "@/views/granary/map/util/zzdhDetail";
import { mapGetters } from "vuex";
// import { zlMixin } from "@/util/mixin/zlMixin";
import { findOrgCompanyByType } from "@/api/map";
import { findIndexByName } from "@/util/index";
import { get } from "@/api/index";
export default {
  // mixins: [zlMixin],
  components: {
    cName,
    cDetail,
  },
  computed: {
    ...mapGetters(["layerComponent", "fromPath"]),
  },
  watch: {
    layerComponent(val) {
      this.pointChoose(val);
    },
  },
  data() {
    return {
      rightPath: "zzglRgihtDrawer",
      type: "",
      map: null,
      daiArr: [],
      jdArr: [],
      kjArr: [],
      zhwlArr: [],
      ydArr: [],
      hoverList: [],
      param: {},
      ncIndex: null,
      ncCode: "",
      poisiton: {},
      pointList: [],
      baseList: [],
      zhwlList: [],
      hoverArr: [],
      beltObj: {},
      areaList: [],
      pointAnchor: [20, 50],
      baseAnchor: [10, 50],
      djd: [10, 50],
      ydAnchor: [10, 40],
      ydtAnchor: [10, 40],
      ydwAnchor: [10, 55],
      mianArr: [],
      btmList: [
        {
          name: "红色区域为茂名市荔枝优势产区产业园（荔枝种植面积40万亩）",
          pic: require("images/map/red.jpg"),
        },
        {
          name: "粉色区域为茂名荔枝主产区（面积超过10000亩以上镇街）",
          pic: require("images/map/fs.jpg"),
        },
        {
          name: "浅粉色区域为茂名荔枝产区（面积超过1000亩以上镇街）",
          pic: require("images/map/dfs.jpg"),
        },
        {
          name: "示范果园",
          pic: require("images/map/sfgy.png"),
        },
        {
          name: "种植大户",
          pic: null,
        },
        {
          name: "贡园",
          pic: require("images/map/gy2.png"),
        },
      ],
      // btmList: [
      //   {
      //     name: "面积>40万亩",
      //     pic: require("images/map/red.jpg"),
      //   },
      //   {
      //     name: "面积>1万亩",
      //     pic: require("images/map/fs.jpg"),
      //   },
      //   {
      //     name: "面积>1000亩",
      //     pic: require("images/map/dfs.jpg"),
      //   },
      //   {
      //     name: "示范果园",
      //     pic: require("images/map/sfgy.png"),
      //   },
      //   {
      //     name: "种植大户",
      //     pic: null,
      //   },
      //   {
      //     name: "贡园",
      //     pic: require("images/map/gy2.png"),
      //   },
      // ],
      curIndex: 0,
      zlpointLayer: null, // 示范果园layer
      zzpointLayer: null, //种植大户layer
      gypointLayer: null, //贡园layer
    };
  },
  mounted() {
    this.initMap();
    this.$bus.$on("updZzdhInfo", (name, point) => {
      this.zzdhInfo(name, point);
    });
  },
  methods: {
    changeMap(url) {
      // 修改切片图层
      this.removemap2();
      if (url) {
        this.tileMapLayer2 = esri.tiledMapLayer({
          url: url,
        });
        window.map.addLayer(this.tileMapLayer2);
      }
    },
    removemap2() {
      // 删除切片图层
      if (this.tileMapLayer2) {
        this.tileMapLayer2._container.remove();
        this.tileMapLayer2.remove();
        this.tileMapLayer2 = null;
      }
    },
    initMap() {
      // 加载底图
      let tileMapUrl = this.$config.tileMapUrl;
      let CRS_4490 = new L.Proj.CRS(
        "EPSG:4490",
        "+proj=longlat +ellps=WGS84 +datum=WGS84 +no_defs",
        {
          resolutions: this.$config.resolutions,
          origin: [-400.0, 399.9999999999998],
        }
      );

      var map = L.map("map", {
        crs: CRS_4490,
        minZoom: this.$config.sZoom,
        maxZoom: this.$config.mZoom,
        zoomControl: false,
      });
      this.map = map; //data上需要挂载
      window.map = map;
      let tileMapLayer = esri.tiledMapLayer({
        url: tileMapUrl,
      });
      tileMapLayer.addTo(map);
      this.map.setView(L.latLng(this.$config.sLat, this.$config.sLng), 0);
      this.changeMap(
        window.__config.VUE_APP_MAP_URL +
          "/rest/services/440900/mm_lz_02/MapServer"
      );
      this.areaLoad();

      this.nowZoom = this.map.getZoom();
      map.on("click", (e) => {
        console.log(e.latlng);
      });
      map.on("move", () => {
        this.param = {};
        this.poisiton = {};
      });
      map.on("zoom", () => {
        this.param = {};
        this.poisiton = {};
      });
    },
    //两区数据加载
    areaLoad() {
      let areaArr = this.$config.areaArr;
      this.mianArr = [];
      for (let i = 0, len = areaArr.length; i < len; i++) {
        L.polygon(areaArr[i].rings, {
          color: areaArr[i].color,
          fillColor: areaArr[i].color,
          fillOpacity: 0.5,
          attributes: this.areaList[i],
        }).addTo(this.map);
      }
      this.zlpointLoad();
    },
    zlpointLoad() {
      //示范果园
      findOrgCompanyByType({ type: 7 }).then((res) => {
        if (this.curIndex === -1) {
          return;
        }
        if (this.zlpointLayer) {
          this.map.removeLayer(this.zlpointLayer);
        }
        this.zlpointLayer = new L.layerGroup();
        let zhuArr = res.data;
        for (let k = 0, len = zhuArr.length; k < len; k++) {
          let pointUrl = require("images/map/sfgy.png");
          var myIcons = "";

          myIcons = L.divIcon({
            html:
              "<div class='indicator-box'><div class='zhu-div-box'><img class='zhu-div-image' src='" +
              pointUrl +
              "'/><div class='zhu-div-text zhu-div-name zhu-yellow' ><span class='zhus-div-name hide yellow'>" +
              zhuArr[k].name +
              "</span></div></div></div>",
            className: "zhu-div-icon",
          });

          let dPoints = L.marker([zhuArr[k].latitude, zhuArr[k].longitude], {
            interactive: true,
            icon: myIcons,
            attributes: zhuArr[k],
          }).addTo(this.zlpointLayer);

          dPoints.on("click", (e) => {
            const data = e.sourceTarget.options.attributes;
            console.log("data2 ===", data);
            this.$store.dispatch("drawer/setGraphic", data);
            setTimeout(() => {
              this.$bus.$emit("yzjdContent", data);
            }, 200);
            // 缓存rightcomponent
            sessionStorage.setItem("rightComponent", this.rightPath);
            setTimeout(() => {
              this.$store.dispatch("drawer/setRightComponent", "yzjdDrawer");
            }, 10);
          });
          dPoints.on("mouseover", (it) => {
            it.sourceTarget
              .getElement()
              .querySelector(".zhus-div-name")
              .classList.remove("hide");
          });
          dPoints.on("mouseout", (it) => {
            it.sourceTarget
              .getElement()
              .querySelector(".zhus-div-name")
              .classList.add("hide");
          });
        }
        this.map.addLayer(this.zlpointLayer);
      });

      //种植大户
      findOrgCompanyByType({ type: 6 }).then((res) => {
        if (this.curIndex === -1) {
          return;
        }
        if (this.zzpointLayer) {
          this.map.removeLayer(this.zzpointLayer);
        }
        this.zzpointLayer = new L.layerGroup();
        // 去重
        let res2 = new Map();
        const zhuArr = res.data.filter((a) => {
          return (
            a.latitude &&
            a.name &&
            !res2.has(a.latitude) &&
            res2.set(a.latitude, 1)
          ); //根据 obj.latitude 来去重.
        });
        // console.log("zzhuArr", zhuArr.length, res.data.length);
        // let zhuArr = res.data;
        // let pointUrl = require("images/map/zzdh.png");
        for (let k = 0, len = zhuArr.length; k < len; k++) {
          if (!zhuArr[k].latitude || !zhuArr[k].name) {
            continue;
          }
          var myIcons = "";
          myIcons = L.divIcon({
            html:
              "<div class='indicator-box'><div class='zhu-div-box'><div class='nopx-point-y'></div><div class='zhu-div-text zhu-div-name zhu-yellow' ><span class='zhus-div-name hide yellow'>" +
              zhuArr[k].name +
              "</span></div></div></div>",
            className: "zhu-div-icon",
          });

          let dPoints = L.marker([zhuArr[k].latitude, zhuArr[k].longitude], {
            interactive: true,
            icon: myIcons,
            attributes: zhuArr[k],
          }).addTo(this.zzpointLayer);

          dPoints.on("click", (e) => {
            this.poisiton = {};
            const data = e.sourceTarget.options.attributes;
            this.zzdhInfo(data.name, e.containerPoint);
          });
          dPoints.on("mouseover", (it) => {
            it.sourceTarget
              .getElement()
              .querySelector(".zhus-div-name")
              .classList.remove("hide");
          });
          dPoints.on("mouseout", (it) => {
            it.sourceTarget
              .getElement()
              .querySelector(".zhus-div-name")
              .classList.add("hide");
          });
        }
        this.map.addLayer(this.zzpointLayer);
      });

      // 贡园
      findOrgCompanyByType({ type: 9 })
        .then((res) => {
          setTimeout(() => {
            window.$loading && window.$loading.close();
          }, 300);
          if (this.curIndex === -1) {
            return;
          }
          if (this.gypointLayer) {
            this.map.removeLayer(this.gypointLayer);
          }
          this.gypointLayer = new L.layerGroup();
          let zhuArr = res.data;
          console.log("gy data =", zhuArr);
          let pointUrl = require("images/map/gy2.png");
          // 解析图片
          let jxarr = [
            {
              name: "根子柏桥贡园",
              fximg: require("images/map/gy/右上.png"),
              className: "right-top",
            },
            {
              name: "霞洞上河贡园",
              fximg: require("images/map/gy/右下.png"),
              className: "right-btm",
            },
            {
              name: "泗水滩底贡园",
              fximg: require("images/map/gy/左上.png"),
              className: "left-top",
            },
            {
              name: "羊角禄段贡园",
              fximg: require("images/map/gy/左下.png"),
              className: "left-btm",
            },
          ];
          for (let k = 0, len = zhuArr.length; k < len; k++) {
            var myIcons = "";
            let index = findIndexByName(zhuArr[k].name, jxarr);
            console.log(" index ===", index);
            if (index === -1) {
              continue;
            }
            // const _data = Object.assign(jxarr[index], zhuArr[k]);

            myIcons = L.divIcon({
              html:
                "<div class='indicator-box'><div class='zhu-div-box'><img class='zhu-div-image' src='" +
                pointUrl +
                "'/><div class='zhu-div-text zhu-div-name zhu-yellow' ><span class='zhus-div-name hide yellow'>" +
                zhuArr[k].name +
                "</span></div></div></div>",
              className: "zhu-div-icon",
              iconAnchor: [6, 52],
            });

            // myIcons = L.divIcon({
            //   html: [
            //     "<div class='indicator-box'><div class='zhu-div-box'><img class='zhu-div-image' src='",
            //     pointUrl,
            //     "'/></div></div>"
            //   ].join(""),
            //   className: "zhu-div-icon",
            //   iconAnchor: [6, 52]
            // });

            let dPoints = L.marker([zhuArr[k].latitude, zhuArr[k].longitude], {
              interactive: true,
              icon: myIcons,
              attributes: zhuArr[k],
            }).addTo(this.gypointLayer);

            dPoints.on("click", (e) => {
              const data = e.sourceTarget.options.attributes;
              sessionStorage.setItem("rightComponent", this.rightPath);
              this.$store.dispatch("drawer/setGraphic", data);
              this.$store.dispatch("drawer/setRightComponent", "zypDrawer");
            });

            dPoints.on("mouseover", (it) => {
              it.sourceTarget
                .getElement()
                .querySelector(".zhus-div-name")
                .classList.remove("hide");
            });
            dPoints.on("mouseout", (it) => {
              it.sourceTarget
                .getElement()
                .querySelector(".zhus-div-name")
                .classList.add("hide");
            });
          }
          this.map.addLayer(this.gypointLayer);
        })
        .catch(() => {
          window.$loading && window.$loading.close();
        });
    },
    showZhwlMap() {
      window.$loading = Loading.service({
        lock: true,
        text: "加载中...",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.8)",
      });
      this.$store.dispatch("map/setMapComponent", "zhwMap");
      //   this.$store.dispatch("drawer/setLeftComponent", "leftDrawer");
      //   this.$store.dispatch("drawer/setRightComponent", "zhwlDrawer");
      this.$store.dispatch("drawer/setNavComponent", "zhwlNavDrawer");
    },
    zzdhInfo(name, point) {
      let obj = {};
      obj.x = point.x;
      obj.y = point.y;
      if (name) {
        get("/api/restful/findOrgCompanyGyByName", {
          name: name,
        }).then((res) => {
          const _d = res.data;
          let chkArr = [
            {
              key: "main_plant_",
              name: "种植品种",
              unit: "",
            },
            {
              key: "area_",
              name: "面积",
              unit: "亩",
            },
            {
              key: "cl_",
              name: "年产量",
              unit: "",
            },
            {
              key: "cb_",
              name: "承包",
              unit: "",
            },
            {
              key: "manage_",
              name: "管理情况",
              unit: "",
            },
            {
              key: "phone_",
              name: "联系方式",
              unit: "",
            },
            {
              key: "level_",
              name: "经营主体级别",
              unit: "",
            },
            {
              key: "brand_",
              name: "商标、品牌",
              unit: "",
            },
            {
              key: "town_",
              name: "所在镇区",
              unit: "",
            },
            {
              key: "vllage_",
              name: "村委名称",
              unit: "",
            },
          ];

          let arr = [];
          if (_d instanceof Array) {
            if (_d.length === 0) {
              return;
            }

            obj.name = _d[0].name_;
            chkArr.forEach((e) => {
              if (_d[0][e.key]) {
                arr.push({
                  name: e.name,
                  num: _d[0][e.key],
                  unit: e.unit || "",
                });
              }
            });

            obj.dataList = arr;
            this.poisiton = obj;
          }
        });
      }
    },
    openNewPage(v) {
      if (v === 1) {
        // 生产监控
        if (process.env.NODE_ENV === "prod1") {
          window.open("/mm/m-screen/zt/zlcy/monitor/index.html");
        } else {
          window.open("http://api.mmlzdsjpt.com/monitor/index.html");
        }
      } else {
        //品种改良
        if (process.env.NODE_ENV === "prod1") {
          window.open("/mm/m-screen/zt/zlcy/bzy/index.html#/bzy");
        } else {
          window.open(
            // "http://api.mmlzdsjpt.com/bzy/index.html" //?client_id=20008
            "http://36.133.149.117:8001/bzy/index.html#/bzy" // change on 2023-0816
          );
        }
      }
    },
  },
  destroyed() {
    clearInterval(this.timer);
    this.$bus.$off("updZzdhInfo");
  },
};
</script>

<style lang="stylus" scoped>
.map
    background none !important
    width 100%
    height calc(100% + 105px)
    z-index 9
    // >>>.leaflet-tile-pane
    // display none
    >>>.leaflet-bar
        display none
    >>>.leaflet-bottom
        display none
    .ncDetail
        position absolute

    >>>
        .zhu-div-icon
            color #fff
        .indicator-box
            position relative
        .indicator-box:hover
            z-index 1000
        .zhu-div-text
            position absolute
            height 30px
            display flex
            justify-content center
            align-items center
            width 0.72rem
        .sLine
            transform translate(28%, -67%)
        .zhu-div-box
            width 10px
            height 10px
            display flex
            justify-content center
            align-items center
            flex-wrap wrap
        .zhu-div-image
            width 31px
        .zhu-div-name
            top -30px
            text-align center
        .zhus-div-name.hide
            display none
        .zhus-div-name
            z-index 9
            font-size 0.08rem
            border 1px #fff solid
            border-radius 5px
            padding 2px 10px
            white-space nowrap
        .yellow
            background-color rgba(0, 126, 120, 0.8)
        .green
            background-color rgba(112, 173, 71, 0.8)
        .purple
            background-color rgba(112, 48, 160, 0.8)
        .blue
            background-color rgba(65, 114, 202, 0.8)
        .red
            background-color rgba(192, 0, 0, 0.8)
        .zhu-red
            top 6px
            left -140px
        .nopx-left-btm
            position absolute
            left -120px
            top 17px
        .nopx-left-top
            position absolute
            left: -138px;
            top: -50px;
        .nopx-right-top
            position absolute
            left 14px
            top -19px
        .nopx-right-btm
            position absolute
            left: 14px;
            top: 18px;
        .nopx-right-top-box
            position absolute
            left 144px
            transform: translateY(-50%);
        .nopx-right-btm-box
            position absolute
            left 120px
            bottom -150px
        .nopx-left-top-box
            position absolute
            left -64px
            transform: translateX(-100%);
            top: -178px;
        .nopx-left-btm-box
            position absolute
            left: -105px;
            transform: translateX(-100%);
            bottom: -115px;
        .nopx-pic1
            position absolute
            top -50px
        .nopx-point-y
          width 6px
          height 6px
          border-radius 50%
          background #f3d013
.zhwl-map-btn
  position absolute
  top 20%
  right 27%
  z-index 10000
  padding 8px 14px
  font-size 14px
  color #fff
  border-radius 4px
  border 1px solid #00b1cf
  background-color rgba(1,30,47,0.8)
  box-shadow inset 0 0 10px #00b1cf
  cursor pointer
.zzgl-nav-bar
  width 12%
@media (max-width 1280px)
    .mapDiv
        transform scale(0.75)
    .map
        >>>
            .zhu-div-image
                width 28px
            .zhu-div-text
                width 1.11rem !important
            .zhus-div-name
                font-size 0.11rem !important
</style>
